// Hero.jsx
import React from 'react';
import './hero.css';
import homepageImages from '../../assets/homepage/homePageImage.png';
import BulletPoints from './bulletPoints';


export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero__content">
        <h1 id="hero-heading">
          Certified Healthcare & Safety Supplies, Delivered Reliably.
        </h1>

        <p className="hero__subhead">
          Comprehensive range across surgical, disposable, safety, and medical furniture categories to fit every need..
        </p>
<BulletPoints />
        {/* <ul className="hero__bullets" aria-label="Key benefits">
          <li>Bulk procurement made simple with transparent pricing, GST-compliant invoicing, and hassle-free reordering.</li>
          <li>Expert assistance to help you select the right products for patient care, workplace safety, and hygiene standards.</li>
          <li>Scalable solutions for single practices to multi-site institutions with consistent supply continuity.</li>
        </ul> */}

       

        {/* <ul className="hero__trust" aria-label="Certifications">
          <li><img src="/iso.svg" alt="ISO certified" /></li>
          <li><img src="/ce.svg" alt="CE compliant" /></li>
          <li><img src="/fda.svg" alt="FDA listing available" /></li>
          <li><img src="/bis.svg" alt="BIS compliant" /></li>
        </ul> */}
      </div>

      <div className="hero__media" role="img" aria-label="Healthcare products collage" style={{'--hero-bg': `url(${homepageImages})`}} />
    </section>
  );
}
